import { CallCenterMonitorRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Obtener_Articulos_Orden_Request = async (pToken, EmpresaId, CallCenterId, EsEcommerce, OrdenGrupo) => {
    const data = { EmpresaId, CallCenterId, EsEcommerce, OrdenGrupo };
    const result = await fetch(CallCenterMonitorRutas.Obtener_Articulos_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Conteo_Ordenes_Request = async (pToken, EmpresaId, CallCenterId) => {
    const data = { EmpresaId, CallCenterId };
    const result = await fetch(CallCenterMonitorRutas.Obtener_Conteo_Ordenes, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Detalles_Orden_Request = async (pToken, EmpresaId, CallCenterId, EsEcommerce, OrdenGrupo) => {
    const data = { EmpresaId, CallCenterId, EsEcommerce, OrdenGrupo };
    const result = await fetch(CallCenterMonitorRutas.Obtener_Detalles_Orden, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Estatus_Request = async (pToken, EmpresaId) => {
    const result = await fetch(CallCenterMonitorRutas.Obtener_Estatus, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(EmpresaId)
    });
    return await GetResponseBody(result);
};

export const Obtener_Ordenes_Request = async (pToken, EmpresaId, CallCenterId, SucursalId, Estado, FechaActivaIni, FechaActivaFin, EstadoExpress) => {
    const data = { EmpresaId, CallCenterId, SucursalId, Estado, FechaActivaIni, FechaActivaFin, EstadoExpress };
    const result = await fetch(CallCenterMonitorRutas.Obtener_Ordenes, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Tiempos_Ordenes_Request = async (pToken, EmpresaId, CallCenterId, SucursalId, Estado, EstadoExpress) => {
    const data = { EmpresaId, CallCenterId, SucursalId, Estado, EstadoExpress };
    const result = await fetch(CallCenterMonitorRutas.Obtener_Tiempos_Ordenes, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};